import React, { type FC } from 'react';
import { Hidden, Stack } from 'braid-design-system';
import { TableHeader } from './TableHeader';

interface TableBodyLayoutProps {
  body: JSX.Element | JSX.Element[];
  pagination: JSX.Element | null;
}

export const TableLayout: FC<TableBodyLayoutProps> = ({ body, pagination }) => (
  <Stack space="xlarge">
    <Stack space="xsmall">
      <Hidden below="tablet">
        <TableHeader />
      </Hidden>
      {body}
    </Stack>
    {pagination}
  </Stack>
);
